const skills = {
  1: [ // Front-End
    { title: "HTML", level: 5 },
    { title: "CSS", level: 4 },
    { title: "JavaScript", level: 4 },
    { title: "Tailwind CSS", level: 2 },
    { title: "React JS", level: 3 },
    { title: "Redux", level: 3 },
  ],
  2: [ // Back-End
    { title: "Node.js", level: 5 },
    { title: "MongoDB", level: 4 },
    { title: "Git", level: 3 },
    { title: "SQL", level: 2 },
    { title: "Linux", level: 2 },
    { title: "Express.js", level: 4 },
  ],
  3: [ // Technical Authoring
    { title: "SA-(WDM)", level: 3 },
    { title: "AIRBUS-TOOlS", level: 4 },
    { title: "Analysis", level: 4 },
    { title: "Mock-UP", level: 4 },
    { title: "MPM-GPP", level: 5 },
    { title: "MODE'S", level: 5 },
  ],
};

export default skills;
